import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheckErrno } from '../utils';

export interface GetLocationOptions extends Partial<GeneralInvokeOption> {
  useFetchData?: boolean;
  invalidParamObj?: '';
}

/**
 * ```js
 *   ma.getLocation({
 *     useFetchData:false
 *     success(res) {},
 *     fail(res) {},
 *     complete(res) {},
 *   })
 * ```
 */

// 获取当前地理位置信息
export function getLocation(option?: GetLocationOptions) {
  const fixedOption = Object.assign(
    {
      useFetchData: false
    },
    option
  );
  if (paramCheckErrno(APINames.Native.GET_LOCATION, fixedOption, { useFetchData: false})) {
    return MacleJSBridge.beforeInvoke(APINames.Native.GET_LOCATION, fixedOption);
  }
  return fixedOption.invalidParamObj;
}
